// extracted by mini-css-extract-plugin
export default {"background":"GI","weightImage":"HI","drinkImage":"II","content":"JI","rtbLeft":"KI","rtbRight":"LI","rtbLeftMobile":"MI","imageContainer":"NI","rtbBox":"OI","line":"PI","rtbDesktop":"QI"};
    if(module.hot) {
      // 1713361651683
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  